var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4444_25276",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 11,
    width: 18,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.707 11.9913L22.364 17.6483C22.5515 17.8359 22.6568 18.0902 22.6568 18.3553C22.6568 18.6205 22.5515 18.8748 22.364 19.0623L16.707 24.7193C16.5184 24.9015 16.2658 25.0023 16.0036 25C15.7414 24.9977 15.4906 24.8925 15.3052 24.7071C15.1198 24.5217 15.0146 24.2709 15.0123 24.0087C15.01 23.7465 15.1108 23.4939 15.293 23.3053L19.243 19.3553L6 19.3553C5.73478 19.3553 5.48043 19.25 5.29289 19.0624C5.10536 18.8749 5 18.6205 5 18.3553C5 18.0901 5.10536 17.8358 5.29289 17.6482C5.48043 17.4607 5.73478 17.3553 6 17.3553L19.243 17.3553L15.293 13.4053C15.1975 13.3131 15.1213 13.2027 15.0689 13.0807C15.0165 12.9587 14.9889 12.8275 14.9877 12.6947C14.9866 12.5619 15.0119 12.4303 15.0622 12.3074C15.1125 12.1845 15.1867 12.0728 15.2806 11.9789C15.3745 11.885 15.4861 11.8108 15.609 11.7605C15.7319 11.7102 15.8636 11.6849 15.9964 11.6861C16.1292 11.6872 16.2604 11.7148 16.3824 11.7672C16.5044 11.8196 16.6148 11.8958 16.707 11.9913Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4444_25276)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 36,
    transform: "matrix(1 0 0 -1 0 36)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowbtn);
export default __webpack_public_path__ + "static/media/arrowbtn.a8289e9d29871251b3f5b330b69cf8d8.svg";
export { ForwardRef as ReactComponent };